/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compress_TitleInputs */

const en_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compress Text`)
};

const fr_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compresser le Texte`)
};

const de_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text komprimieren`)
};

const it_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimi testo`)
};

const ru_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сжать текст`)
};

const es_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimir texto`)
};

const zh_cn2_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压缩文本`)
};

const ja_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを圧縮`)
};

const hi_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को संपीड़ित करें`)
};

const pt_pt2_compress_title = /** @type {(inputs: Compress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimir texto`)
};

/**
* | output |
* | --- |
* | "Compress Text" |
*
* @param {Compress_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compress_title = /** @type {((inputs?: Compress_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compress_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compress_title(inputs)
	if (locale === "de") return de_compress_title(inputs)
	if (locale === "it") return it_compress_title(inputs)
	if (locale === "ru") return ru_compress_title(inputs)
	if (locale === "es") return es_compress_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compress_title(inputs)
	if (locale === "ja") return ja_compress_title(inputs)
	if (locale === "hi") return hi_compress_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compress_title(inputs)
	return en_compress_title(inputs)
});